import React, { useEffect } from "react";
import Home from "./components/Home";
import About from "./components/About";
import Experience from "./components/Experience";
import Projects from "./components/Projects";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import Design from "./data/design";
import "./App.css";

const App: React.FC = () => {
  useEffect(() => {
    const root = document.documentElement;
    Object.keys(Design.colors).forEach((key) => {
      root.style.setProperty(
        `--${key}`,
        Design.colors[key as keyof typeof Design.colors]
      );
    });
    root.style.setProperty("--border-radius", Design.borderRadius);
    root.style.setProperty("--padding", Design.spacing.padding);
    root.style.setProperty("--box-shadow", Design.boxShadow);
    root.style.setProperty("--box-shadow-hover", Design.boxShadowHover);
  }, []);

  return (
    <>
      <NavBar />
      <main>
        <Home />
        <hr className="divider"></hr>
        <About />
        <hr className="divider"></hr>
        <Experience />
        <hr className="divider"></hr>
        <Projects />
      </main>
      <Footer />
    </>
  );
};

export default App;
